<template>
  <div class="s-dealmakers-container">
    <topNav></topNav>
    <div class="s-dealmakers-top">
      <div class="banner w1300 marginAuto"></div>
    </div>
    <div class="s-dealmakers-body">
      <div class="conditions w1300 marginAuto mt10">
        <el-row class="conditions-row">
          <div class="conditions-row-1">
            <div class="conditions-colName">病虫害类型：</div>
            <div class="conditions-colContent">
              <span v-for="(itm,ind) in matchUpClass" :key="ind" class="col-span" :class="ind ==active1?'active':''" @click="checkmatch(1,ind,itm,'病虫害类型')">{{ itm.name }}</span>
            </div>
          </div>

          <div class="conditions-row-1">
            <div class="conditions-colName">病虫害分类：</div>
            <div class="conditions-colContent conditions-colContent-last">
              <span v-for="(itm,ind) in transactionList" :key="ind" class="col-span" :class="ind ==active4?'active':''" @click="checkmatch(4,ind,itm,'病虫害分类')">{{ itm.CODE_NAME }}</span>
            </div>
          </div>
        </el-row>
      </div>
      <div class="w1300 marginAuto queryDiv">
        <div class="query">
          <el-input v-model="queryKey" placeholder="请输入关键词搜索" class="search_input">
            <!-- @keyup.enter.native="getListByPageInfo" -->
            <template v-slot:suffix>
              <div @click="handlematchUpQuery">
                <i class="el-input__icon el-icon-search"></i>
              </div>
              <!-- @click="getListByPageInfo" -->
            </template>
          </el-input>
          <div class="issue" @click="handleSetRelease">搜索</div>
        </div>
      </div>
      <div class="w1300 marginAuto s-transaction-wrap" v-if="showList.length > 0">
        <!-- 展示列表 -->
        <div @click="goDetail(item)" class="showlistclass" v-for="(item,index) in showList" :key="index">
          <div class="left_img">
            <img :src="item.diseaseImg" alt="">
          </div>
          <div class="right_box">
            <div class="r_top">
              <h1 style="display: inline-block;font-size: 18px;"><!--<span style="font-weight: normal;">病虫害名称：</span>-->{{ item.diseaseName }}</h1>
            </div>
            <div class="r_bottom">
              <p v-html="item.symptomDescription" :title="item.symptomDescription">

              </p>
            </div>
            <p style="color: #666666;">上传时间：{{ item.createDate }}</p>
          </div>
        </div>
        <div style="display:flex;justify-content:flex-end;width:100%">
          <el-pagination class="tab_pagination" background :pageSize="pageSize" layout="prev, pager, next" @current-change="currentChange" :total="total"></el-pagination>
        </div>
      </div>
      <div v-else>
        <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
      </div>
    </div>
    <footer-nav></footer-nav>

  </div>
</template>

  <script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import { pageList, diseaseAndPestCode } from "../utils/api/diseasesInsectPests";

export default {
  name: "priceQuotation",
  components: { topNav, footerNav },
  data() {
    return {
      active1: 0,
      active2: 0,
      active3: 0,
      active4: 0,
      type: 1,
      typeId: "",
      classifyId: "",
      // varietyId: "",
      currentPage: 1, // 页码
      pageSize: 3, // 每页显示数量
      total: 1, // 总数
      queryKey: "",
      setReleaseDialog: false, // 撮合发布
      matchUpTitle: "信息发布",
      defaultImg: require("../assets/image/dealmakers/default.png"),
      showList: Array(10).fill({
        imgurl: require("../assets/image/dealmakers/default.png"),
        describ: `1、发病初期，嫩叶和幼茎上会出现针头状的褐色小点，之后慢慢扩大成直径为0.25-0.5毫米左右的圆形病斑，病斑的颜色一般为灰白色，中央凹陷，边缘有暗褐色或紫褐色的隆起线。环境较潮湿时，病斑上还会散生黑色的小粒点。<br />2、发病后期，病斑会出现互相融合的情况，形成不规则的大斑，叶脉发病时会导致叶片扭曲畸形。嫩茎上的病斑呈暗褐色，之后变为灰白色，并出现小黑粒点。病情严重时会蔓及全梢，导致梢枯。`,
        time: "2023/07/04",
        title: "茶紫纹羽病",
      }),
      matchUpClass: [
        { name: "病害类型", val: "0" },
        { name: "虫害类型", val: "1" },
        // { name: "枝干部", val: "stems" },
      ],
      matchUpProduct: [],
      transactionList: [
        // { name: "地下害虫", val: "地下害虫" },
        // { name: "害螨", val: "害螨" },
        // { name: "食叶性害虫", val: "食叶性害虫" },
        // { name: "吸汁性害虫", val: "吸汁性害虫" },
        // { name: "钻蛀性害虫", val: "钻蛀性害虫" },
      ],
      //   positionType
      positionType: "",
      noDataImg:require('../assets/image/pest/no-data.jpg')
    };
  },
  mounted() {
    this.diseaseAndPestCode();
    // 获取省
  },
  methods: {
    // 获取病虫害类型接口
    async diseaseAndPestCode() {
      let res = await diseaseAndPestCode({ type: this.active1 });
      //   console.log("res", res.data.data);
      if ([0, 200].includes(res.data.code)) {
        this.transactionList = res.data.data;
        this.transactionList.unshift({ CODE_NAME: "全部", CODE_VALUE: "" });
        this.positionType = this.transactionList[this.active4].CODE_VALUE;
        this.pageList();
      }
    },
    async pageList() {
      let obj = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        positionType: this.positionType,
        type: this.active1,
        title: this.queryKey,
      };
      let res = await pageList(obj);
      if (res.data.code == 0) {
        this.showList = res.data.data.records;
        this.showList.forEach((item) => {
          if (this.active1 == 0) {
            item[
              "diseaseImg"
            ] = `${this.diseasesInsectPestsImgURL}${item.diseaseImg}`;
          }
          if (this.active1 == 1) {
            item[
              "diseaseImg"
            ] = `${this.diseasesInsectPestsImgURL}${item.pestImg}`;
            item["diseaseName"] = item.pestName;
            item["symptomDescription"] = item.pestDescribe;
          }
        });
        this.total = res.data.data.total;
        // this.total = 100;
        // if (this.currentTab == 0) {
        //   this.diseasesDataList = res.data.data.records;
        // } else {
        //   if (res.data.data.records.length > 0) {
        //     this.diseasesDataList = res.data.data.records.map((item) => {
        //       item.pathogenUrl = item.pestUrl;
        //       return {
        //         pathogenUrl: item.pestUrl,
        //         diseaseName: item.pestName,
        //         id: item.id,
        //       };
        //     });
        //   } else {
        //     this.diseasesDataList = [];
        //   }
        // }
      }
    },
    // 切换页码
    currentChange(val) {
      this.currentPage = val;
      this.pageList();
      //   this.getMatchUpListPage();
    },
    goDetail(item) {
      //   this.$router.push({ path: "matchUpDetails", query: { id: item.id } });
      this.$router.push({
        path: "/resourceLibraryDetail",
        query: {
          id: item.id,
          type: this.active1,
          positionType: `0${this.active1}`,
        },
      });
    },
    handlematchUpQuery() {},

    // 撮合信息切换撮合类型
    checkmatch(type, val, typeName, name) {
      if (type == 1) {
        this.active1 = val;
        this.active4 = 0;
        this.diseaseAndPestCode();
      }
      if (type == 4) {
        this.active4 = val;
        this.positionType = this.transactionList[this.active4].CODE_VALUE;
        this.pageList();
      }
    },
    handleSetRelease() {
      this.currentPage = 1;
      this.pageList();
    },
  },
};
</script>
  <style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/dealmakers.scss";
.showlistclass {
  width: 100%;
  box-sizing: border-box;
  //margin-bottom: 10px;
  border-bottom: 1px dashed rgba(84, 174, 73, 0.5);
  cursor: pointer;
  display: flex;
  padding: 10px 0 20px;

  .left_img {
    height: 200px;
    width: 200px;
    border: 1px solid #6cbe3e;
    border-radius: 6px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
  }
  .right_box {
    padding: 0 10px;
    box-sizing: border-box;
    width: calc(100% - 200px);
    .r_top {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      font-family: PingFangSC;
      font-weight: bold;
      color: #262626;
      height: 18px;
      line-height: 18px;
      padding-top: 10px;
      padding-bottom: 12px;
    }
    .r_bottom {
      width: 100%;
      height: calc(100% - 70px);
      //font-size: 17px;
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
      }
    }
  }
}
.showlistclass {
  &:hover {
    background: #f0f4ef;

    .r_top {
      color: #54ae49;
    }
  }
}
.el-empty__description{
		p{
			font-size: 16px;
		}
}
</style>
